import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { useFrequencyType, FrequencyType } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<FrequencyType>
      useData={useFrequencyType}
      config={{
        ...moduleConfig,
        getDetailSections,
        getStatusBadges,
      }}
    />
  );
};

export default Detail;
